import { useAppSelector } from '@monorepo/shared';
import { selectDebugKey } from '@monorepo/shared/store/authSlice';
import { isExpanded } from '@monorepo/shared/store/sidemenuSlice';
import { Button, Modal, Nav, Sidebar, Sidenav } from 'rsuite';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectHasGroup } from '@monorepo/shared/store/groupSlice';
import {
  selectCurrentAccount,
  selectSystem
} from '@monorepo/shared/store/accountSlice';
import { useState } from 'react';
import serviceTermPdf from '/SD-FortiSOC-Cloud.pdf';

export const Sidemenu = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const handleClose = () => setOpen(false);
  const { pathname } = useLocation();
  const debugKey = useAppSelector(selectDebugKey);
  const menuExpanded = useAppSelector(isExpanded);
  const hasGroup = useAppSelector(selectHasGroup);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const systemData = useAppSelector(selectSystem);

  interface IgetIcon {
    name: string;
    active?: boolean;
  }
  const getDashboardIcon = ({ name, active }: IgetIcon) => (
    <div
      style={{
        width: '52px',
        height: '41px',
        display: 'grid',
        placeItems: 'center'
      }}
    >
      <i
        className={`icon-${name}`}
        style={{
          fontSize: '14px'
        }}
      />
    </div>
  );
  return (
    <>
      <Sidebar
        width={menuExpanded ? 166 : 54}
        style={{ position: 'relative', backgroundColor: 'var(--fc-blue)' }}
        collapsible
        className="frame-sidebar"
      >
        <div style={{ height: '100%' }}>
          <Sidenav style={{ height: '100%' }} defaultOpenKeys={['2']}>
            <Sidenav.Body>
              <Nav
                activeKey="1"
                className={menuExpanded ? 'expanded' : 'collapsed'}
              >
                {hasGroup && (
                  <Nav.Item
                    eventKey="1"
                    active={pathname.includes('group')}
                    icon={getDashboardIcon({
                      name: 'fortinetone-manageUserGroupIcon',
                      active: pathname.includes('group')
                    })}
                    onClick={() => {
                      navigate('/group/accounts', {
                        state: {
                          debug_key: debugKey
                        }
                      });
                    }}
                  >
                    <div className="sidenav-text">Group</div>
                  </Nav.Item>
                )}
                <Nav.Item
                  eventKey="2"
                  active={pathname.includes('organization')}
                  icon={getDashboardIcon({
                    name: 'fortinetone-manageUserIcon',
                    active: pathname.includes('organization')
                  })}
                  onClick={() => {
                    navigate(
                      `${
                        currentAccount?.account_id && !currentAccount?.group_id
                          ? `/organization/account`
                          : '/cred/ou'
                      }`,
                      {
                        state: {
                          debug_key: debugKey,
                          account_id: currentAccount?.account_id
                        }
                      }
                    );
                  }}
                >
                  <div className="sidenav-text">Account</div>
                </Nav.Item>
              </Nav>
            </Sidenav.Body>
            <div
              className="rs-sidenav-toggle app-version"
              onClick={() => {
                setOpen(true);
              }}
            >
              {menuExpanded ? (
                <AppInfo />
              ) : (
                <span className="version-info">@</span>
              )}
            </div>
          </Sidenav>
        </div>
      </Sidebar>
      <Modal size={'sm'} open={open} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>
            <AppInfo />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              textAlign: 'center',
              borderTop: '1px solid var(--fsr-space)',
              paddingTop: '20px'
            }}
          >
            <Button appearance="link" href={serviceTermPdf} target="_blank">
              Terms of Service
            </Button>
            <Button
              appearance="link"
              href={systemData?.privacy_url}
              target="_blank"
            >
              Privacy Policy
            </Button>
            <Button
              appearance="link"
              href={systemData?.release_note_url}
              target="_blank"
            >
              Release Notes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AppInfo = () => {
  const systemData = useAppSelector(selectSystem);
  return (
    <div className="version-info" style={{ textAlign: 'center' }}>
      <span>FortiSOC</span>&nbsp;
      <span>{systemData?.portal_version}</span>
      <br />
      <span
        style={{
          fontSize: '7px',
          textTransform: 'uppercase',
          color: '#5a5959',
          letterSpacing: '2.1px',
          lineHeight: '10px'
        }}
      >
        Enabled By FortiSOC
      </span>
    </div>
  );
};
